import React from "react";
import PropTypes from "prop-types";
// import RichTextEditor from "react-rte";
import QuillNoSSRWrapper from "react-quill";



function TextEditor(props) {
  const { onChange,value } = props;


  return <QuillNoSSRWrapper style={{height:'100%',width:'100%'}} theme="snow" value={value} onChange={onChange} />;
}
TextEditor.propTypes = {
  value:PropTypes.string,
  onChange: PropTypes.func,

};
//   TextEditor.defaultProps = {
//     label: "Submit",
//   };
export default TextEditor;
